export type RosterViewMode = 'true-empty' | 'active-empty' | 'populated';

/** Derive Members page mode from roster counts. Archived does not affect selection. */
export function getRosterViewMode(
  active: number,
  pending: number,
  _archived: number
): RosterViewMode {
  if (active === 0 && pending === 0) return 'true-empty'; // includes archived-only
  if (active === 0) return 'active-empty'; // pending ≥ 1
  return 'populated';
}
